import {  useAdminDashboardContext } from "../context/AdminDashboardContext";
import NavigationSidebar from "../components/AdminDashBoard/Tabs/NavigationSidebar";
import UnifiedNotificationCenter from "../components/Notifications/UnifiedNotificationCenter";
import { useState } from "react";
import moment from "moment-timezone";

const AdminDashboard = () => {
  // Add state to track sidebar expansion
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

const {
    useEffect,
    Swal,
    useNavigate,
    axios,
    DatePicker,
    HTMLContent,
    motion,
    AnimatePresence,
    Header,
    Footer,
    CreateRentalModal,
    EditRentalModal,
    LoadingSpinner,
    NotificationSystem,
    InsuranceExpirationAlert,
    MaintenanceNotification,
    RentalCalendar,
    UpcomingPickups,
    VehicleUtilization,
    UpcomingReturns,
    EmployeeManagement,
    tabs,
    CarDetailsModal,
    FinanceManagement,
    PartnerManagement,
    CreateCarModal,
    generateDailyPlanPDF,
    TransferModal,
    categories,
    TransferePage,
    VehicleInstancesPanel,
    AdminDashBoardTabsContainer,
    TabsButtons,
    fetchPartners,
    verifyAuth,
    getImagePath,
    filterCars,
    paginateCars,
    paginateRentals,
    // Refs
    formRef,
    editTourRef,
    // Loading and errors
    isLoading,
    setIsLoading,
    error,
    setError,
    // Active tab
    activeTab,
    setActiveTab,
    // Cars
    carsData,
    setCarsData,
    editingCar,
    setEditingCar,
    selectedCar,
    setSelectedCar,
    carDetailsModalOpen,
    setCarDetailsModalOpen,
    deletingCarId,
    setDeletingCarId,
    searchQuery,
    setSearchQuery,
    selectedCategory,
    setSelectedCategory,
    selectedTransmission,
    setSelectedTransmission,
    isCreatingCar,
    setIsCreatingCar,
    createCarModalOpen,
    setCreateCarModalOpen,
    CARS_PER_PAGE,
    setCarsPerPage,
    carPage,
    setCarPage,
    paginatedCars,
    setPaginatedCars,    // Rentals
    rentalsData,
    setRentalsData,
    selectedRental,
    setSelectedRental,
    isEditRentalModalOpen,
    setIsEditRentalModalOpen,
    isUpdatingRental,
    setIsUpdatingRental,
    updatingRentalId,
    setUpdatingRentalId,
    deletingRentalId,
    setDeletingRentalId,
    isRentalModalOpen,
    setIsRentalModalOpen,
    rentalSearch,
    setRentalSearch,
    rentalStatusFilter,
    setRentalStatusFilter,
    dateFilter,
    setDateFilter,
    filteredRentals,
    setFilteredRentals,
    paginatedRentals,
    setPaginatedRentals,
    totalRentalPages,
    setTotalRentalPages,
    serverSideRentals,
    // Coupons
    couponsData,
    setCouponsData,
    creatingCoupon,
    setCreatingCoupon,
    deletingCouponId,
    setDeletingCouponId,
    editingCoupon,
    setEditingCoupon,
    // Transfers
    transfersData,
    setTransfersData,
    isCreateTransferModalOpen,
    setIsCreateTransferModalOpen,
    transferSearch,
    setTransferSearch,
    transferStatusFilter,
    setTransferStatusFilter,
    expandedTransfer,
    setExpandedTransfer,
    deletingTransferId,
    setDeletingTransferId,
    updatingTransferStatus,
    setUpdatingTransferStatus,
    assigningDriverToTransfer,
    setAssigningDriverToTransfer,
    transferDateFilter,
    setTransferDateFilter,
    transferTimeFilter,
    setTransferTimeFilter,
    transferPartnerFilter,
    setTransferPartnerFilter,
    creatingPartnerTransfer,
    setCreatingPartnerTransfer,
    // Tours
    toursData,
    setToursData,
    tourBookingsData,
    setTourBookingsData,
    // Season & Pricing
    settingSeasonalPrice,
    setSettingSeasonalPrice,
    seasonalPricing,
    setSeasonalPricing,
    editingSeasonalPrice,
    setEditingSeasonalPrice,
    basePrice,
    setBasePrice,
    durationDiscounts,
    setDurationDiscounts,
    // Drivers
    driversData,
    setDriversData,
    creatingDriver,
    setCreatingDriver,
    editingDriver,
    setEditingDriver,
    deletingDriverId,
    setDeletingDriverId,
    driverSearch,
    setDriverSearch,
    driverVehicleTypeFilter,
    setDriverVehicleTypeFilter,
    // Employees
    employeesData,
    setEmployeesData,
    employeeSearch,
    setEmployeeSearch,
    creatingEmployee,
    setCreatingEmployee,
    editingEmployeeId,
    setEditingEmployeeId,
    changingEmployeePasswordState,
    setChangingEmployeePasswordState,
    deletingEmployeeId,
    setDeletingEmployeeId,
    currentPage,
    setCurrentPage,
    // Partners
    partnersData,
    setPartners,
    // Other UI
    isEditModalOpen,
    setIsEditModalOpen,
    expandedCustomer,
    setExpandedCustomer,
    // Payments
    updatingPaymentId,
    setUpdatingPaymentId,
    // Turnover
    turnoverPage,
    setTurnoverPage,
    // SweetAlert2
    MySwal,

    isTomorrow,
    setIsTomorrow,
    isToday,
    setIsToday,
    onCreateTour,
    onEditTour,
    onRentalUpdate,
    onSeasonSelect,
    onCarCreate,
    onCarDelete,
    onRentalDelete,
    onDurationDiscountUpdate,
    onPaymentStatusUpdate,
    onHandleCarUpdate,
    onHandleDriverEdit,
    onCreateTransfer,
    onAssignDriverToTransfer,
    onCreateDriver,
    onDeleteDriver,
    onUnassignDriver,
    onDeleteTransfer,
    onUpdateTransferStatus,
    onCouponEdit,
    onCouponDelete,
    onCouponCreate,
    onRentalStatusUpdate,
    onDriverPasswordChange,
    onGetDailyTurnover,
    onGetTomorrowTurnover,
    onFilterRentals,
    formatDateTime,
    RENTALS_PER_PAGE,
    partners,
    fetchData,
    auth,
    cars,
    rentals,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    fetchDurationDiscounts,
    handleRentalStatusUpdate,
    updatingCarId,
    changingDriverPassword,
    getDailyTurnover,
    getTomorrowTurnover,
    setChangingDriverPassword,
onRentalPageChange,
allRentalsData
  } = useAdminDashboardContext(); 



  const navigate = useNavigate();

  // handle car edit
  const handleEditCar = (car) => {
    setSelectedCar(car);
    setCarDetailsModalOpen(true);
  };
  // set is today
  function handleSetIsToday() {
    // Get ALL today's data directly without pagination using allRentalsData
    const today = moment().startOf("day");
    const allPickups = (allRentalsData?.allRentals || []).filter(
      (rental) =>
        moment(rental.pickupDateTime).isSame(today, "day") &&
        rental.status !== "cancelled"
    );
    const allReturns = (allRentalsData?.allRentals || []).filter(
      (rental) =>
        moment(rental.returnDateTime).isSame(today, "day") &&
        rental.status !== "cancelled"
    );
    generateDailyPlanPDF(allPickups, allReturns, false);
  }

  // set is tomorrow
  function handleSetIsTomorrow() {
    // Get ALL tomorrow's data directly without pagination using allRentalsData
    const tomorrow = moment().add(1, "day").startOf("day");
    const allPickups = (allRentalsData?.allRentals || []).filter(
      (rental) =>
        moment(rental.pickupDateTime).isSame(tomorrow, "day") &&
        rental.status !== "cancelled"
    );
    const allReturns = (allRentalsData?.allRentals || []).filter(
      (rental) =>
        moment(rental.returnDateTime).isSame(tomorrow, "day") &&
        rental.status !== "cancelled"
    );
    generateDailyPlanPDF(allPickups, allReturns, true);
  }

  // filteredCars
  const filteredCars = filterCars(carsData, selectedCategory, selectedTransmission, searchQuery);

  useEffect(() => {
    const filteredRentalsList = onFilterRentals();

    setFilteredRentals(filteredRentalsList);

    // Now, paginate the filtered rentals
    const paginatedRentalsList = paginateRentals({
      filteredRentals: filteredRentalsList,
      RENTALS_PER_PAGE,
      setTotalRentalPages,
      currentPage,
      setCurrentPage,
    });

    setPaginatedRentals(paginatedRentalsList);

    }, [rentalsData, rentalSearch, rentalStatusFilter, dateFilter, RENTALS_PER_PAGE, currentPage]);
  
  // get partners
  useEffect(() => { fetchPartners({ partners, setPartners, setError }); }, []);

  // paginate cars
  useEffect(() => {
      const paginatedCarsList = paginateCars(carPage, setCarPage, filteredCars, CARS_PER_PAGE);
      setPaginatedCars(paginatedCarsList);
  }, [searchQuery, selectedCategory, selectedTransmission, carsData, CARS_PER_PAGE]);

  //verify auth and fetch duration discounts
  useEffect(() => { verifyAuth({ fetchData, auth, navigate, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError, fetchDurationDiscounts, setDurationDiscounts }); }, [navigate]);


  useEffect(() => {if (isTomorrow) { handleSetIsTomorrow();} }, [isTomorrow]);
  useEffect(() => {if (isToday) { handleSetIsToday();} }, [isToday]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header />
        <div className="flex-grow flex items-center justify-center">
          <LoadingSpinner />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    
    <div className="min-h-screen flex flex-col bg-[#F8F8F9] Aleo">
      <Header />
      <div className="flex-grow container mx-auto py-4 md:py-6 lg:py-8 xl:py-10 px-4 max-w-[1800px] xl:px-8">
        <div className="rounded-lg shadow-lg p-4 md:p-6 bg-[#F6F9FF] border-2 border-gray-300">
          <div className="flex justify-between items-center mb-6 md:mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
              Admin Dashboard
            </h1>
            <div className="flex items-center space-x-2 md:space-x-4">
              <UnifiedNotificationCenter
                rentals={rentalsData}
                onRentalUpdate={handleRentalStatusUpdate}
                token={localStorage.getItem("adminToken")}
              />
            </div>
          </div>            <div className="flex flex-col lg:flex-row lg:gap-6">
            {/* Navigation positioned properly on desktop */}
            <div className={`lg:flex ${isSidebarExpanded ? 'lg:w-60' : 'lg:w-16'} transition-all duration-300`}>
              <NavigationSidebar 
                tabs={tabs} 
                activeTab={activeTab} 
                setActiveTab={setActiveTab} 
                onSidebarToggle={setIsSidebarExpanded}
              />
            </div>
            
            {/* Main Content Area - flex-1 ensures it takes up remaining space */}
            <div className="flex-1 mt-6 lg:mt-0 bg-white rounded-lg shadow-md border border-gray-200 p-3 md:p-4 overflow-x-auto transition-all duration-300">
              <AdminDashBoardTabsContainer
                activeTab={activeTab} 
                carsData={carsData} 
                searchQuery={searchQuery} 
                setSearchQuery={setSearchQuery} 
                isCreatingCar={isCreatingCar} 
                setCreateCarModalOpen={setCreateCarModalOpen} 
                selectedCategory={selectedCategory} 
                setSelectedCategory={setSelectedCategory} 
                selectedTransmission={selectedTransmission} 
                setSelectedTransmission={setSelectedTransmission} 
                categories={categories} 
                paginatedCars={paginatedCars} 
                handleEditCar={handleEditCar} 
                getImagePath={getImagePath} 
                handleCreateCar={onCarCreate} 
                createCarModalOpen={createCarModalOpen} 
                selectedCar={selectedCar} 
                carDetailsModalOpen={carDetailsModalOpen} 
                setCarDetailsModalOpen={setCarDetailsModalOpen} 
                setSelectedCar={setSelectedCar} 
                handleCarUpdate={onHandleCarUpdate} 
                handleCarDelete={onCarDelete} 
                handleSeasonSelect={onSeasonSelect} 
                updatingCarId={updatingCarId} 
                deletingCarId={deletingCarId} 
                settingSeasonalPrice={settingSeasonalPrice} 
                editingSeasonalPrice={editingSeasonalPrice} 
                setEditingSeasonalPrice={setEditingSeasonalPrice} 
                seasonalPricing={seasonalPricing} 
                setCarPage={setCarPage} 
                carPage={carPage} 
                LoadingSpinner={LoadingSpinner} 
                CreateCarModal={CreateCarModal} 
                CarDetailsModal={CarDetailsModal} 
                currentPage={currentPage} 
                setCurrentPage={setCurrentPage} 
                handleSetIsTomorrow={handleSetIsTomorrow} 
                handleSetIsToday={handleSetIsToday} 
                handlePaymentStatusUpdate={onPaymentStatusUpdate} 
                filteredRentals={filteredRentals} 
                getDailyTurnover={onGetDailyTurnover} 
                getTomorrowTurnover={onGetTomorrowTurnover} 
                setTurnoverPage={setTurnoverPage} 
                turnoverPage={turnoverPage} 
                setDateFilter={setDateFilter} 
                dateFilter={dateFilter} 
                totalRentalPages={totalRentalPages} 
                rentalStatusFilter={rentalStatusFilter} 
                rentalSearch={rentalSearch} 
                setRentalSearch={setRentalSearch} 
                setRentalStatusFilter={setRentalStatusFilter} 
                setIsRentalModalOpen={setIsRentalModalOpen} 
                fetchData={fetchData} 
                updatingRentalId={updatingRentalId} 
                updatingPaymentId={updatingPaymentId} 
                setSelectedRental={setSelectedRental} 
                setIsEditRentalModalOpen={setIsEditRentalModalOpen} 
                handleRentalStatusUpdate={onRentalStatusUpdate} 
                handleRentalDelete={onRentalDelete} 
                formatDateTime={formatDateTime} 
                expandedCustomer={expandedCustomer} 
                setExpandedCustomer={setExpandedCustomer} 
                rentalsData={rentalsData} 
                driversData={driversData} 
                transfersData={transfersData} 
                partnersData={partnersData} 
                transferSearch={transferSearch} 
                setTransferSearch={setTransferSearch} 
                transferStatusFilter={transferStatusFilter} 
                setTransferStatusFilter={setTransferStatusFilter} 
                transferDateFilter={transferDateFilter} 
                setTransferDateFilter={setTransferDateFilter} 
                handleCreateTransfer={onCreateTransfer} 
                handleTransferStatusUpdate={onUpdateTransferStatus} 
                updatingTransferStatus={updatingTransferStatus} 
                handleUnassignDriver={onUnassignDriver} 
                handleAssignDriverToTransfer={onAssignDriverToTransfer} 
                assigningDriverToTransfer={assigningDriverToTransfer} 
                handleTransferDelete={onDeleteTransfer} 
                deletingTransferId={deletingTransferId} 
                tourBookingsData={tourBookingsData} 
                expandedTransfer={expandedTransfer} 
                setExpandedTransfer={setExpandedTransfer} 
                handleCreateTour={onCreateTour} 
                tours={tours} 
                toursData={toursData} 
                tourBookings={tourBookings} 
                handleEditTour={onEditTour} 
                driverSearch={driverSearch} 
                setDriverSearch={setDriverSearch} 
                driverVehicleTypeFilter={driverVehicleTypeFilter} 
                setDriverVehicleTypeFilter={setDriverVehicleTypeFilter} 
                handleDriverCreate={onCreateDriver} 
                handleDriverEdit={onHandleDriverEdit} 
                creatingDriver={creatingDriver} 
                editingDriver={editingDriver} 
                changingDriverPassword={changingDriverPassword} 
                handleDriverPasswordChange={onDriverPasswordChange} 
                handleDriverDelete={onDeleteDriver} 
                deletingDriverId={deletingDriverId} 
                couponsData={couponsData} 
                durationDiscounts={durationDiscounts} 
                handleDurationDiscountUpdate={onDurationDiscountUpdate} 
                editingCoupon={editingCoupon} 
                setEditingCoupon={setEditingCoupon} 
                handleCouponEdit={onCouponEdit} 
                creatingCoupon={creatingCoupon}                handleCouponCreate={onCouponCreate} 
                handleCouponDelete={onCouponDelete} 
                serverSideRentals={serverSideRentals}
                allRentalsData={allRentalsData}
              />
            </div>
          </div>
        </div>
        <CreateRentalModal
          isOpen={isRentalModalOpen}
          onClose={() => setIsRentalModalOpen(false)}
          onSuccess={() => {
            setIsRentalModalOpen(false);
            fetchData(cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError);

            Swal({
              title: "Rental Created",
              text: "The rental has been successfully created.",
              icon: "success",
            });
          }}
        />
        <EditRentalModal
          isOpen={isEditRentalModalOpen}
          onClose={() => {
            setIsEditRentalModalOpen(false);
            setSelectedRental(null); // Clear selected rental on close
          }}
          rental={selectedRental} // Pass the selected rental data
          //onUpdate={handleRentalUpdateSubmit} // Pass the actual update handler function
          onUpdate={onRentalUpdate}
          isUpdating={isUpdatingRental} // Pass the loading state
        />
      </div>
      <Footer />
    </div>
  );
};

export default AdminDashboard;
